
import "/root/workspace/crm-pc_pGKl/src/components/HeaderSearch/index.less?modules";
export default {"input": `input-RixsaVUz`,"show": `show-aNETFFrY`,"headerSearch": `headerSearch-XaKK1IrS`}
